/** Pipeline execution display helpers. */

export function isOverallPipelineExecution(row: {
  source_name?: string | null;
  filter_diagnostics?: Record<string, unknown> | null;
}): boolean {
  const source = (row.source_name || '').trim();
  if (source) return false;
  const scope = row.filter_diagnostics?.execution_scope;
  return scope === 'overall' || !source;
}

export function pipelineSourceLabel(row: {
  source_name?: string | null;
  filter_diagnostics?: Record<string, unknown> | null;
}): string {
  if ((row.source_name || '').trim()) {
    return row.source_name!.trim();
  }
  return 'Overall search execution';
}
